import { OnlinePatientManagementContext, RouteLoading } from "@ngt/opms";
import { FC, PropsWithChildren, useContext } from "react";
import { useParams } from "react-router-dom";
import { EConsentUserType, stringToEConsentUserType } from "../../../contexts/EConsentContext";
import EConsentByGuidProvider from "../../providers/form/EConsentByGuidProvider";

export interface IEConsentByGuidRouteProps extends PropsWithChildren {
    formDefinitionCode?: string;
    guid?: string;
    userType?: EConsentUserType;
    
    /**
     * This property determines whether the associated data should be loaded before loading the route.
     */
    loadBeforeMount?: boolean;
}


const EConsentByGuidRoute: FC<IEConsentByGuidRouteProps> = ({
    formDefinitionCode,
    guid,
    userType,

    loadBeforeMount,

    children
}) => {
    const params = useParams();
    const { routeParameters } = useContext(OnlinePatientManagementContext);

    const userTypeToUse = stringToEConsentUserType(params.userType) ?? userType;

    const guidToUse = params.guid ?? guid ?? undefined;
    const formDefinitionIdentifierToUse = params[routeParameters.formDefinitionCode] ?? formDefinitionCode ?? undefined;

    return <EConsentByGuidProvider
        userType={userTypeToUse}
        guid={guidToUse}
        formDefinitionIdentifier={formDefinitionIdentifierToUse}

        loadBeforeMount={loadBeforeMount}
        LoadingComponent={RouteLoading}
    >
        {children}
    </EConsentByGuidProvider>
}

export default EConsentByGuidRoute;